module.exports = __webpack_public_path__ + "img/online.6b84f154.svg";